// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// ** ThemeConfig Import
import themeConfig from "@configs/themeConfig";
import GetConfigWhiteLabel from "../services/config";

const config = GetConfigWhiteLabel();

const initiaPrimaryColorLight = () => {
  const item = config.primaryColor ? `${config.primaryColor}` : "#002a5d";
  return item ? item : {};
};
const initiaPrimaryColorDark = () => {
  const item = config.primaryColor ? `${config.primaryColor}a1` : "#002a5d";
  return item ? item : {};
};
const initiaSecondaryColorLight = () => {
  const item = config.primaryColor ? `${config.secondaryColor}` : "#249984";
  return item ? item : {};
};
const initiaSecondaryColorDark = () => {
  const item = config.primaryColor ? `${config.secondaryColor}a1` : "#249984";
  return item ? item : {};
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    skin: themeConfig.layout.skin,
    isRTL: themeConfig.layout.isRTL,
    layout: themeConfig.layout.type,
    lastLayout: themeConfig.layout.type,
    footerType: themeConfig.layout.footer.type,
    navbarType: themeConfig.layout.navbar.type,
    menuHidden: themeConfig.layout.menu.isHidden,
    contentWidth: themeConfig.layout.contentWidth,
    menuCollapsed: themeConfig.layout.menu.isCollapsed,
    routerTransition: themeConfig.layout.routerTransition,
    navbarColor: themeConfig.layout.navbar.backgroundColor,
    primaryColorLight: initiaPrimaryColorLight(),
    primaryColorDark: initiaPrimaryColorDark(),
    secondaryColorLight: initiaSecondaryColorLight(),
    secondaryColorDark: initiaSecondaryColorDark(),
  },
  reducers: {
    handleRTL: (state, action) => {
      state.isRTL = action.payload;
      window.sessionStorage.setItem(
        "direction",
        JSON.stringify(action.payload),
      );
    },
    handleSkin: (state, action) => {
      state.skin = action.payload;
      window.sessionStorage.setItem("skin", JSON.stringify(action.payload));
    },
    handleLayout: (state, action) => {
      state.layout = action.payload;
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload;
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload;
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload;
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload;
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload;
    },
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload;
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload;
      window.sessionStorage.setItem(
        "menuCollapsed",
        JSON.stringify(action.payload),
      );
    },
    handleRouterTransition: (state, action) => {
      state.routerTransition = action.payload;
    },
  },
});

export const {
  handleRTL,
  handleSkin,
  handleLayout,
  handleLastLayout,
  handleMenuHidden,
  handleNavbarType,
  handleFooterType,
  handleNavbarColor,
  handleContentWidth,
  handleMenuCollapsed,
  handleRouterTransition,
} = layoutSlice.actions;

export default layoutSlice.reducer;
